import React from 'react';

import {GBPreferences} from 'constants/ExportConstants';
import usePreference from 'ui-library/hooks/usePreference';
import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import Modal from 'ui-library/modals/Modal';

export interface GenbankExportPreferences {
  exportAnnotationColors: boolean;
  convertNonStandardAnnotations: boolean;
}

export interface GenbankExportModalProps {
  onRequestClose: () => void;
  onRequestSubmit: (result: GenbankExportPreferences) => void;
}

export default function GenbankExportModal({
  onRequestClose,
  onRequestSubmit,
}: GenbankExportModalProps): JSX.Element {
  const [exportAnnotationColors, setAnnotationColorPreference] = usePreference<boolean>(
    GBPreferences.EXPORT_ANNOTATION_COLORS
  );
  const [convertNonStandardAnnotations, setNonStandardAnnotationsPreference] = usePreference<boolean>(
    GBPreferences.CONVERT_NON_STANDARD_ANNOTATIONS
  );

  return (
    <Modal
      buttons={[{text: 'Submit', submit: true, disabled: false}]}
      onRequestClose={onRequestClose}
      onRequestSubmit={() => {
        onRequestSubmit({
          exportAnnotationColors,
          convertNonStandardAnnotations,
        });
      }}
      title="Export as Multi-part Genbank File"
      dataTestAttrs={{component: 'GenBankExportModal', element: 'root'}}
    >
      <CheckboxInput
        id="export-annotation-colors"
        label="Export Feature Colors"
        checked={exportAnnotationColors}
        onChange={(e) => {
          setAnnotationColorPreference(e.target.checked);
        }}
      />
      <CheckboxInput
        id="convert-non-standard-annotations"
        label="Convert Non-Standard Annotation Types"
        checked={convertNonStandardAnnotations}
        onChange={(e) => {
          setNonStandardAnnotationsPreference(e.target.checked);
        }}
      />
    </Modal>
  );
}
